import { hubScenesCreate } from '../../api/localMeshBot';
import { bugsnagNotify } from '../../containers/ErrorBoundary/utils';
import { toast, TOAST_TYPE } from '../../components/Toast';
import { sequence } from '../common';
import EzloActions from '../EzloActions';

/**
 * Creates a new scene/rule and refreshes the scenes list.
 *
 * Executes two operations sequentially:
 * 1. Creates the scene via hubScenesCreate API
 * 2. Refreshes the local scenes list via Redux action
 *
 * @param {string} serial - Hub serial number
 * @param {Object} rule - Scene/rule configuration object (see hubScenesCreate for structure)
 * @returns {Function} Redux thunk function
 *
 * @example
 * const newRule = {
 *   enabled: true,
 *   name: "Motion Sensor Alert",
 *   when: [{ blockType: "when", ... }],
 *   then: [{ blockType: "then", ... }],
 *   house_modes: ["1", "2", "3", "4"]
 * };
 *
 * dispatch(createRule("90004631", newRule));
 */
export const createRule = (serial, rule) => async (dispatch) =>
    await dispatch(
        sequence(
            [
                [hubScenesCreate, [serial, rule]],
                [EzloActions.refreshSceneList, [serial]],
            ],
            (error) => {
                bugsnagNotify(error, { serial, rule });
                toast(error.message, { type: TOAST_TYPE.ERROR });
            },
        ),
    );
